export const GET_LIST_CONVERTER_KIT_TAGS = "GET_LIST_CONVERTER_KIT_TAGS";
export const GET_LIST_CONVERTER_KIT_TAGS_SUCCESS =
  "GET_LIST_CONVERTER_KIT_TAGS_SUCCESS";
export const GET_LIST_CONVERTER_KIT_TAGS_ERROR =
  "GET_LIST_CONVERTER_KIT_TAGS_ERROR";
